import { scrollTo } from '../helpers/scrollPage';
import { fadeIn, fadeOut } from '../helpers/animations';
const JS_CLASSNAME = 'js-visual-filters';
const SELECTOR = `.${JS_CLASSNAME}`;
export function initVisualFilters() {
    document.querySelectorAll('.visual-filters-v2').forEach((container) => {
        container.querySelectorAll(`${SELECTOR}[data-filter-key]`).forEach(el => {
            el.addEventListener('click', handleVisualFilterClick);
        });
    });
}
export function initTabbableVisualFilters() {
    document.querySelectorAll(".js-tabbable-visual-filter-select").forEach((tab) => {
        tab.addEventListener("click", (e) => {
            const clickedTab = e.target;
            if (!clickedTab.classList.contains("tabbable-visual-filter__button--selected")) {
                const tabs = Array.from(document.querySelectorAll(".js-tabbable-visual-filter-select"));
                tabs.forEach((b) => b.classList.toggle("tabbable-visual-filter__button--selected"));
                const selectedId = clickedTab.dataset.id;
                const filters = Array.from(document.querySelectorAll(".visual-filters-v2"));
                filters.forEach((f) => f.dataset.id === selectedId ? fadeIn(f) : fadeOut(f));
                setFilterContainerHeight(selectedId);
            }
        });
    });
    setFilterContainerHeight();
    initVisualFilters();
}
function handleVisualFilterClick(e) {
    console.log("handleVisualFilterClick");
    const target = e.target;
    const filter = target.classList.contains(JS_CLASSNAME) ? target : target.closest(SELECTOR);
    if (filter) {
        clearFilters();
        applyFilter(filter);
    }
}
/**
 * clears all currently applied filters
 * emulates FilterClearButton.onClearAll without making a server request
 * see: https://boost-pfs-lib-v2-dev-doc.s3.us-west-2.amazonaws.com/components_filter_filter-tree_filter-option-element_filter-clear-button.js.html
 */
function clearFilters() {
    Object.keys(window.Globals.queryParams).filter(queryParam => {
        return queryParam.startsWith(window.Globals.prefix);
    })
        .forEach(qp => window.FilterApi.setParam(qp, null));
    window.FilterApi.setParam('page', 1);
}
/**
 * applies a provided filter and scrolls to results
 *
 */
function applyFilter(filter) {
    const { filterKey, filterValue, filterTag, filterType, rangeMin, rangeMax } = filter.dataset;
    console.log(`applying filter key: ${filterKey}, value: ${filterValue}, tag: ${filterTag || 'n/a'}`);
    const lowerCaseKey = filterKey.toLowerCase().replace(/\s/g, "_");
    const isProductOption = ['size', 'fit'].includes(lowerCaseKey);
    const param = isProductOption ? `pf_opt_${lowerCaseKey}` : filterType === 'range' ? `pf_p_${lowerCaseKey}` : `pf_t_${lowerCaseKey}`;
    const value = isProductOption ? filterValue : filterType === 'range' ? `${rangeMin}:${rangeMax}` : filterTag;
    window.FilterApi.setParam(param, [value]);
    function handleAfterFilter() {
        scrollTo(document.getElementById('collection-results'), focusOnFirstSearchResult);
        window.removeEventListener("filter.afterFilter", handleAfterFilter);
    }
    window.addEventListener("filter.afterFilter", handleAfterFilter);
    window.FilterApi.applyFilter('filter');
}
function focusOnFirstSearchResult() {
    const container = document.querySelector('.boost-pfs-filter-products');
    if (container) {
        const first = container.querySelector('a.boost-pfs-filter-product-item-image-link');
        if (first) {
            first.focus({ preventScroll: true });
        }
    }
}
// updates the container height so that css transition animation can run
function setFilterContainerHeight(id) {
    const visualFilterSelector = id ? `.visual-filters-v2--${id}` : `.visual-filters-v2`; // will select the first viz filter if no id defined
    const filterContainer = document.querySelector(".tabbable-visual-filter__filter-container");
    filterContainer.style.height = getComputedStyle(filterContainer.querySelector(visualFilterSelector)).height;
}
